import { Component } from '@angular/core';
import { AuxDataAccountsTableColumnDirective } from '../auxiliary-data-accounts-table-column.directive';

@Component({
  selector: 'aux-city-column',
  template: `
    {{ element.address.city }}
  `,
})
export class CityColumnComponent extends AuxDataAccountsTableColumnDirective {}
